import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BrowserRouter as Router } from 'react-router-dom';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { AppRouter } from '@/components/AppRouter';
import { GlobalStyles } from '@/theme';
function App() {
    return (_jsxs(_Fragment, { children: [_jsx(GlobalStyles, {}), _jsx(Router, { children: _jsxs("div", { className: "app", children: [_jsx(Header, {}), _jsx("main", { className: "app-main", children: _jsx(AppRouter, {}) }), _jsx(Footer, {})] }) })] }));
}
export default App;
